module.exports = __webpack_public_path__ + "static/img/gaozhonglishi8.c0cf9c84.jpg";